export const CXP_ROUTE_TOKEN_TASKS = '' as const;

export const CXP_ROUTE_TOKEN_REQUEST_DETAIL = 'request' as const;
export const CXP_ROUTE_PARAM_REQUEST_ID = 'requestId' as const;

/**
 * Per-item detail panel (PP-3753). It is a child of the redesigned CRL page
 * route, rendered into the named `panel` outlet so it sits ALONGSIDE the list
 * on desktop. URL shape (auxiliary route):
 *   .../request/:requestId(panel:item/:itemId)
 * Constructed via `[{ outlets: { [CXP_ROUTE_OUTLET_PANEL]: [CXP_ROUTE_TOKEN_ITEM_DETAIL, itemId] } }]`.
 */
export const CXP_ROUTE_OUTLET_PANEL = 'panel' as const;
export const CXP_ROUTE_TOKEN_ITEM_DETAIL = 'item' as const;
export const CXP_ROUTE_PARAM_ITEM_ID = 'itemId' as const;

/**
 * Which panel tab is showing, as a query param so it survives a refresh and can
 * be linked to: `.../request/:requestId(panel:item/:itemId)?tab=comments`.
 * Absent means the default tab, so an ordinary open carries no param at all.
 */
export const CXP_QUERY_PARAM_PANEL_TAB = 'tab' as const;
export const CXP_DEFAULT_PANEL_TAB = 'documents' as const;

/**
 * eSign detail, a sibling of the request path rather than a variant of it. An eSign request is
 * a bundle shell with no items, so the CRL detail has nothing to show for one; giving it its own
 * token means the URL names which kind of request it points at, and the router can pick the page
 * from the link alone.
 *
 * Both eSign routes still carry `:requestId`, so everything keyed on the param name — the route
 * params service, the lockdown guard — reads them exactly as it reads the request path.
 *
 * URL shape: `esign/:requestId`.
 */
export const CXP_ROUTE_TOKEN_ESIGN_DETAIL = 'esign' as const;

/**
 * Signing surface for an eSign request, nested under its detail route so the
 * signer's URL still names the request they came from: `esign/:requestId/sign`.
 */
export const CXP_ROUTE_TOKEN_ESIGN_SIGN = 'sign' as const;

export const CXP_ROUTE_TOKEN_DELIVERABLE_DETAIL = 'deliverable' as const;
export const CXP_ROUTE_PARAM_DELIVERABLE_ID = 'deliverableId' as const;

/** Names which signature the signing route is for, when a bundle holds several of the caller's. */
export const RECIPIENT_ID_QUERY_PARAM = 'recipientId';
